import {Component} from '@angular/core';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {Api} from '@shared/constants/common-field.constants';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {CommandService} from '@core/services/command.service';
import {take} from 'rxjs/operators';
import {GridValueChangeEvent} from '@shared/models/common.models';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {PlatformCommand} from '@shared/commands/command-base';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformQueryService} from '@core/services/platform-query.service';

@Component({
    standalone: false,
    selector: 'app-apply-data-mapping-detail-view-dialog',
  templateUrl: './apply-data-mapping-detail-view-dialog.component.html',
  styleUrls: ['./apply-data-mapping-detail-view-dialog.component.scss']
})
export class ApplyDataMappingDetailViewDialogComponent implements IDialogView {
  data: DialogModel;
  invalidateSubject = new InvalidateSubject();
  parameters = {};
  api: string;
  sourceType: string;
  serviceName: string;
  sortFieldKey: string;
  sortDirection: string;
  dataMappingItemId: string;

  constructor(private dialogService: DialogService,
              private commandService: CommandService,
              private platformQueryService: PlatformQueryService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService) {
    this.sourceType = 'ApplyDataMapping';
    this.api = Api.FileStoreApi;
  }

  private static getUpdateDataMappingFieldItem(): PlatformCommand {
    return new PlatformCommand('UpdateDataMappingFieldItemCommand', Api.FileStoreApi);
  }

  onColumnHeaderButtonClicked($event: any) {
  }

  onSelectionChanged($event: any) {
  }

  onGridCellValueChange($event: GridValueChangeEvent) {
    console.log('[Event]', $event);
    if ($event.fieldDefinition) {
      switch ($event.fieldDefinition.key) {
        case 'Destination':
          this.handleTargetMapping($event);
          break;
      }
    }
  }

  onOkClicked(): boolean {
    return true;
  }

  onCancelClicked(): any {
  }

  private handleTargetMapping($event: GridValueChangeEvent) {
    if ($event.isRemove) {
      this.executeRemoveField($event);
    } else {
      this.openSelectFieldDialog($event);
    }
  }

  private executeRemoveField($event: GridValueChangeEvent) {
    const command = ApplyDataMappingDetailViewDialogComponent.getUpdateDataMappingFieldItem();
    command.fieldValues['IsRemove'] = true;
    command.fieldValues['DataMappingFieldItemId'] = $event.item.id;
    this.executeCommandApi(command);
  }

  private openSelectFieldDialog($event: GridValueChangeEvent) {
    const query = new PlatformQuery();
    query.api = Api.FileStoreApi;
    query.name = 'DataMappingFieldDefinitionsQuery';
    query.isCamelCase = true;
    query.fieldValues['DataMappingItemId'] = $event.item.cells.DataMappingItemId.value;
    query.fieldValues['SourceFieldDataType'] = $event.item.cells.SourceFieldDataType.value;
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(res => {
      if (res && res.fieldValues['FieldDefinitions']) {
        console.log('[DataMappingQuery FieldDefinitions]', res.fieldValues['FieldDefinitions']);
        const fieldDefinitions = res.fieldValues['FieldDefinitions'];
        const displayObjectKey = res.fieldValues['DisplayObjectKey'];
        this.openExistingFieldSelectorDialog($event, fieldDefinitions, displayObjectKey);
      } else if (res.fieldValues['Error']) {
        this.snackBarService.showError(res.fieldValues['Error']);
      }
    });

  }

  private executeCommandApi(command: PlatformCommand) {
    console.log('[Executing PlatformCommand] -> ', command.name);
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(res => {
          console.log('Command Response', res);
          this.fuseSplashScreenService.hide();
          if (res.fieldValues['SnackBarMessage']) {
            const duration = res.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(res.fieldValues['SnackBarMessage'], duration);
          }
          this.invalidateSubject.invalidate();
        },
        error => {
          console.error('Failed ToolBarComponent command', error);
          this.fuseSplashScreenService.hide();
        });
    }
  }

  private openExistingFieldSelectorDialog($event: GridValueChangeEvent, fieldDefinitions: any[], displayObjectKey: string) {
    const dialogModel = DialogModel.create(`Select Field for ${$event.item?.cells?.Source.displayText}`,
      'PlatformToolDropDownDialogComponent',
      {
        dropDownList: fieldDefinitions,
        selectedValue: fieldDefinitions[0],
        label: 'Select Field *',
        displayObjectKey: displayObjectKey ?? 'header',
        event: $event
      }, '400px', '400px');

    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(payload => {
      if (payload.action === 'OK') {
        const command = ApplyDataMappingDetailViewDialogComponent.getUpdateDataMappingFieldItem();
        command.fieldValues['IsNewField'] = false;
        command.fieldValues['TargetFieldKey'] = payload.data.input.selectedValue.key ?? payload.data.input.selectedValue.fieldKey;
        command.fieldValues['DataMappingFieldItemId'] = payload.data.input.event.item.id;
        command.fieldValues['TargetFieldHeader'] = payload.data.input.selectedValue[dialogModel.input.displayObjectKey];
        this.executeCommandApi(command);
      }
    });
  }
}
